import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { BecasService } from '../../services/becas/becas.service';
import { CursoService } from '../../services/curso/curso.service';

import { Tipos } from '../../models/tipos/tipos.model';
import { Usuario } from '../../models/usuario/usuario.model';
import { Curso } from '../../models/curso/curso.model';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';
import { TiposService } from '../../services/tipos/tipos.service';
import { ProductosService } from '../../services/productos/productos.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { TextosService } from '../../services/textos/textos.service';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
    selector: 'app-becas',
    templateUrl: '../../pages/becas/becas.component.html',
    styleUrls: ['../../pages/becas/becas.component.css']
})
export class BecasComponent implements OnInit
{
    options = { autoClose: true, keepAfterRouteChange: false }

    tiposBeca: Tipos[]; postulantes: Usuario[]; cursos: Curso[];

    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    solicitaDiagnostico:boolean = false
    excelencia:boolean = false
    rol:string = ""
    seleccionPostulante: boolean = true

    cantidadArchivos: any = 1
    beca = { afiliado: "", tipoBeca: "", postulante: "", curso: "", nota: "", diagnostico: "", email: "", archivo: [], archivoTest: null,archivoTest2: null,archivoTest3: null,archivoTest4: null,archivoTest5: null,archivoTest6: null }
    textos: any
    linkTexto: any

    constructor(private router:Router, private becasService:BecasService, private dialog: MatDialog,
                private cursoService:CursoService, private tiposService: TiposService,
                private productosService: ProductosService, private postulacionesBecasService: PostulacionesService,
                private textosService: TextosService) {  }

    ngOnInit(): void
    {
        this.rol = localStorage.getItem("rol")

        if(this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO')
        {
            this.validaCarencia(1, localStorage.getItem("rutUsuario"))
        }

        this.loadData()
    }

    loadData()
    {
        let vm = this

        this.productosService.obtieneProductos().then
        (
            productos =>
            {
                let fechaFin

                productos[0].parametros.forEach(parametro =>
                {
                    console.log(parametro)

                    if(parametro.descripcion == 'FECHA_HASTA_POSTULACION') fechaFin = new Date(parametro.valor + 'T00:00')
                })

                if(fechaFin < new Date())
                {
                    vm.openAlertDialog('El tiempo para postular a las becas ya ha expirado.', 'btn-danger')

                    vm.router.navigate(['/index'])
                }
            }
        )
        this.textosService.obtieneTextos()
        .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "BECA")?.valor;             
        })
        .catch(error => {
        console.error('Error al obtener los textos:', error);
        });
        console.log('linkTexto',vm.linkTexto)
    }

    ingresaAfiliado()
    {
        this.beca.tipoBeca = "", this.beca.postulante = "", this.beca.curso = "", this.beca.nota = "",
        this.beca.diagnostico = "", this.beca.archivo=[],
        this.postulantes = [], this.tiposBeca = [], this.cursos = [], this.beca.archivoTest = null, this.beca.archivoTest2= null,
        this.beca.archivoTest3= null, this.beca.archivoTest4= null, this.beca.archivoTest5= null, this.beca.archivoTest6=null

        if(Rut( this.beca.afiliado))
        {
            var rut = this.beca.afiliado.split('.').join('').split('-')[0];

            this.validaCarencia(1, rut);
        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
    }

    seleccionaTipoBeca()
    {
        this.beca.postulante = "", this.beca.curso = "", this.beca.nota = "", this.cursos = [],
        this.beca.diagnostico = ""

        this.seleccionPostulante = false

        if(this.beca.tipoBeca == "2") { this.solicitaDiagnostico = true } else { this.solicitaDiagnostico = false }

        if(this.beca.tipoBeca == "1") { this.excelencia = true } else { this.excelencia = false }
    }

    beneficiarioEtapaEscolar(beneficiario: any)
    {
        let vm = this

        if(this.beca.tipoBeca != "")
        {
            this.cursoService.traeCursos(this.beca.tipoBeca).then
            (
                (cursos: Curso[]) =>
                {
                    let cursosDisponibles: Array<Curso> = []

                    if (beneficiario == 'TITULAR')
                    {
                        cursos.forEach(
                            curso => { if(curso.postulaAfiliado) { cursosDisponibles.push(curso) } }
                        )
                    }
                    else
                    {
                        cursos.forEach(
                            curso => { if(curso.postulaCarga) { cursosDisponibles.push(curso) } }
                        )
                    }

                    vm.cursos = cursosDisponibles
                    vm.beca.curso = ""
                }
            )
            .then ( () => vm.beca.curso = "" )
            .catch ( error =>
            {
                console.log(error)

                vm.openAlertDialog('Ha ocurrido un problema al cargar los cursos.', 'btn-dark')
            } )
        }
        else { this.openAlertDialog('Seleccione primero un Tipo de Beca.', 'btn-dark') }
    }

    seleccionaArchivo(event: any, numero: number)
    {
        if(event.target.files.length > 0)
        {
            console.log(event.target.files[0].type)

            let vm = this
            let reader = new FileReader()
            this.beca.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
            reader.readAsDataURL(event.target.files[0])

            reader.onload = function() {
                vm.beca.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }

                console.log(vm.beca.archivo)
            }
        }
    }


    validaCarencia(producto: any, rut: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let vm = this

        this.productosService.cumpleCarencia(producto, rut).then
        (
            () =>
            {
                Swal.close();
                vm.traeTipos(1)
                vm.traePostulantes(rut)
            }
        )
        .catch ( error =>
        {
            if(error.status == 401 || error.status ==500)
            {
                vm.openAlertDialog('El Usuario no cumple la carencia mínima para postular.', 'btn-danger')
                  Swal.close();
                vm.router.navigate(['/index'])
            }
            else   
            {
                vm.openAlertDialog('Afiliado no cumple con periodo de carencia.', 'btn-danger')
                  Swal.close();
                vm.beca.afiliado = ""
            }
        } )
    }

    traeTipos(producto: any)
    {
        let vm = this

        this.tiposService.traeTipos(producto).then
        (
            (tipos: Tipos[]) =>
            {
                if(tipos.length > 0) { vm.tiposBeca = tipos }

                else
                {
                    vm.openAlertDialog('El período de postulación se encuentra cerrado.', 'btn-dark')

                    vm.router.navigate(['/index'])
                }
            }
        )
        .catch ( error => console.log(error) )
    }

    traePostulantes(rut: any)
    {
        let vm = this

        this.becasService.traePostulantes(rut).then
        (
            (usuario: Usuario) =>
            {
                vm.beca.email = usuario.email;
                vm.nombreUsuario = usuario.nombres + ' ' + usuario.apellidoPaterno;

                let usuariosPostulantes: Array<Usuario> = [];

                usuariosPostulantes.push({ id: usuario.id, nombres: usuario.nombres,
                apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
                fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
                dv: usuario.dv, parentesco: 'TITULAR' });

                usuario.carga ? usuario.carga.forEach( carga =>
                {
                    carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)

                    usuariosPostulantes.push(carga)
                }) : null

                vm.postulantes = usuariosPostulantes
            }
        )
        .catch ( error =>
        {
            console.log(error)

            vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-dark')
        } )
    }


        sumaArchivo() {
          if(this.cantidadArchivos<=5){

            this.cantidadArchivos = this.cantidadArchivos + 1
          }
        }

        restaArchivo() { this.cantidadArchivos = this.cantidadArchivos - 1
           this.beca.archivo.splice(this.cantidadArchivos, 1);

      
          }

    solicitar(form: NgForm)
    {

      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
        let usuarioId: any, cargaId: any, titular: any
        let tipoAfiliado = this.beca.postulante.split('-')[2]
        let rut = this.beca.postulante.split('-')[0]
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        if(tipoAfiliado == 'TITULAR')
        {
            titular = true
            usuarioId = this.beca.postulante.split('-')[1]
        }
        else
        {
            titular = false
            cargaId = this.beca.postulante.split('-')[1]
        }

        let cursoId = this.beca.curso.split('-')[0]
        let notaMinima = this.beca.curso.split('-')[2]

        if(this.excelencia && notaMinima > this.beca.nota)
        {
            Swal.close();
            this.openAlertDialog('La nota ingresada no supera la nota mínima de postulación.', 'btn-dark')

            return false
        }
        else if(this.excelencia && this.beca.nota > '7.000')
        {
            Swal.close();
            this.openAlertDialog('La nota ingresada supera la nota máxima de postulación.', 'btn-dark')

            return false
        }

        if(!form.valid || !this.beca.archivo)
        {
            Swal.close();
            this.openAlertDialog('Debe seleccionar un archivo', 'btn-dark')

            return false
        }

        let sizeArchivos=0;
        for(let i = 0; i < this.cantidadArchivos; i++)
        {
          sizeArchivos +=  this.beca.archivo[i].size;
          if(sizeArchivos>25000000 ){
            this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-dark')
            Swal.close();
            return;
          }
          this.beca.archivo[i].sizeArchivos
            if(this.beca.archivo[i].extension != "application/pdf" && this.beca.archivo[i].extension != "image/jpeg" &&
            this.beca.archivo[i].extension != "image/jpg" && this.beca.archivo[i].extension != "image/png")
            {
                this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')

                Swal.close();
                return false
            }

        }

        this.beca.curso = cursoId

        delete this.beca.postulante

        console.log(this.beca)

        let vm = this

        this.postulacionesBecasService.sinPostulacionesVigentes(1, rut, titular).then
        (
            response =>
            {
                console.log(response);

                vm.openAlertDialog('El rut ya tiene una solicitud de Beca ingresada, favor revisar.', 'btn-danger')

                vm.seleccionPostulante = true;

                form.reset()
                Swal.close();
                return
            }
        )
        .catch ( error =>
        {
            console.log(error)

            vm.becasService.ingresaBeca(vm.beca, usuarioId, cargaId, vm.nombreUsuario,idUsuarioSesion).then
            (
                () =>
                {
                    vm.openAlertDialog('Solicitud ingresada exitosamente', 'btn-success')
                     vm.beca.archivo = [];
                    vm.seleccionPostulante = true;
                    Swal.close();
                    form.reset()
                }
            )
            .catch( errorFinal =>
            {
                console.log(errorFinal)
                Swal.close();
                vm.openAlertDialog('Ha ocurrido un error al ingresar la beca', 'btn-danger')
            })
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) { this.router.navigate(['/index']) }
        })
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
